/**
 * Default configs for various widgets.
 * Combination of MMF.Global, MMF.Sites
 */

mmf_modules.define('utils/settings',[
    'context_vars/utils/settings',
    'jquery',
    'utils/utils'
], function (
    context,
    $,
    utils
) {
    'use strict';

    var settings = utils.extend(true, {}, context);

    settings.chart_colors = (function () {
        var out = [{
            linearGradient: {
                x1: 0,
                y1: 0,
                x2: 1,
                y2: 0
            },
            stops: [
                [0, 'rgb(134, 202, 247)'],
                [1, 'rgb(112, 192, 243)']
            ]
        }];

        if ($('#site_cdphp').length > 0) {
            out = [{
                linearGradient: {
                    x1: 0,
                    y1: 0,
                    x2: 1,
                    y2: 0
                },
                stops: [
                    [0, 'rgb(6, 177, 134)'],
                    [1, 'rgb(4, 186, 141)']
                ]
            }];
        }
        return out;
    }());

    // Global defaults for elevation type charts
    settings.Charts = {
        Cadence: {
            color: 'rgb()'
        },
        Elevation: {
            color: 'rgb(219, 11, 14)',
            fillColor: {
                linearGradient: [0, 0, 0, 170],
                stops: [
                    [0, 'rgba(207, 204, 175, 0.6)'],
                    [0.15, 'rgba(207, 204, 175, 0.6)'],
                    [1, 'rgba(235, 235, 235, 0.25)']
                ]
            }
        },
        HeartRate: {
            color: 'rgb()'
        },
        Pace: {
            color: 'rgb(18, 175, 48)'
        },
        Speed: {
            color: 'rgb()'
        }
    };

    settings.Highcharts = {
        chart: {
            animation: false,
            spacingRight: 20,
            type: 'line',
            zoomType: 'x'
        },
        title: false,
        credits: { enabled: false },
        legend: { enabled: false },
        plotOptions: {
            series: {
                animation: false,
                lineWidth: 2,
                marker: {
                    enabled: false,
                    states: {
                        hover: { enabled: true }
                    }
                },
                shadow: false
            }
        },
        tooltip: { shared: false },
        xAxis: {
            allowDecimals: false,
            labels: {
                formatter: function () {
                    return this.value;
                }
            },
            title: { text: '' }
        },
        yAxis: {
            startOnTick: true,
            endOnTick: true,
            title: {
                style: {
                    color: 'rgb(0, 0, 0)',
                    fontSize: '12px'
                },
                text: ''
            },
            gridLineColor: 'rgba(0, 0, 0, 0.15)',
            gridLineDashStyle: 'ShortDash',
            labels: {
                formatter: function () {
                    return this.value;
                }
            }
        }
    };

    settings.Sites = {
        'run': {},
        'ride': {},
        'walk': {},
        'hike': {},
        'tri': {},
        'humana': {},
        'cdphp': {}
    };

    settings.defaultDisplayUnits = {
        'mi': {
            'short': 'mi',
            plural: 'miles',
            singular: 'mile'
        },
        'km': {
            'short': 'km',
            plural: 'kilometers',
            singular: 'kilometer'
        },
        'ft': {
            'short': 'ft',
            plural: 'feet',
            singular: 'feet'
        },
        'm': {
            'short': 'm',
            plural: 'meter',
            singular: 'meters'
        },
        'mph': {
            plural: 'mph',
            singular: 'mph'
        },
        'km/h': {
            plural: 'km/h',
            singular: 'km/h'
        },
        'min/mi': {
            plural: 'min/mi',
            singular: 'min/mi'
        },
        'min/km': {
            plural: 'min/km',
            singular: 'min/km'
        },
        'lb': {
            plural: 'lbs',
            singular: 'lb'
        },
        'kg': {
            plural: 'kgs',
            singular: 'kg'
        },
        'kCal': {
            plural: 'kCal',
            singular: 'kCal'
        },
        'kJ': {
            plural: 'kJ',
            singular: 'kJ'
        }
    };

    return settings;
});

